import script from "./base-text-toolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-text-toolbar.vue?vue&type=script&setup=true&lang=ts"

import "./base-text-toolbar.vue?vue&type=style&index=0&id=de7f8aa2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de7f8aa2"]])

export default __exports__